import { render, staticRenderFns } from "./CanistersSplitWidgetComponent.vue?vue&type=template&id=4076a788&"
import script from "./CanistersSplitWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./CanistersSplitWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports